import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { FIB } from "../../config/constants";
import { mdRender } from "../../functions/remarkable";
var POST_NAVIGATION_DELAY = FIB.POST_NAVIGATION_DELAY;
export default {
  name: 'GetStarted',
  components: {
    FibFindOutMore: require('@/components/FindOutMore').default,
    FibStaffButton: require('@/components/FIBStaffButton').default
  },
  data: function data() {
    return {
      // TODO: Make sure all this stuff is loaded dynamically for each branch/company after FC components signed off
      cover: true,
      isRestaurant: true,
      slide: '1',
      useParallax: false
    };
  },
  computed: {
    branchDetails: get('config/branchDetails'),
    logoRestaurant: get('theme/logo'),
    showAboutVisit: get('checkIn/showAboutVisit'),
    isApp: get('config/isApp'),
    bgImage: function bgImage() {
      return this.$store.getters['theme/bgImage'];
    },
    headerStyles: function headerStyles() {
      return {
        background: "linear-gradient(130deg, ".concat(this.theme.gradientColorStart, ", ").concat(this.theme.gradientColorStart, " 20%, ").concat(this.theme.gradientColorEnd, ")")
      };
    },
    location: function location() {
      var _this$branchDetails;

      return ((_this$branchDetails = this.branchDetails) === null || _this$branchDetails === void 0 ? void 0 : _this$branchDetails.name) || '';
    },
    logoStyle: function logoStyle() {
      if (this.isRestaurant) {
        return {
          width: '50px',
          position: 'absolute',
          left: '0',
          top: '0'
        };
      }

      return '90px';
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$store.commit('app/SET_PAGE_LOADING', true);

                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var nextPage;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (_this.isApp) {
                            // If the Get Started page is accessed through the app,
                            // the visit date and survey start date needs to be set
                            // and the customer should be redirected to the questions page.
                            // The visit date and survey start date will be the same for the app.
                            // set date of visit in store
                            _this.$store.set('checkIn/visitDetails@datetime', moment().format('YYYY-MM-DD HH:mm:ss')); // Set the survey start time to now and generate a new guid to be used.


                            _this.$store.commit('checkIn/startTime', moment().format('YYYY-MM-DD HH:mm:ss'));

                            _this.$store.commit('checkIn/guid', uuidv4());
                          } // Load correct survey


                          _context.next = 3;
                          return _this.$store.dispatch('checkIn/nextPage');

                        case 3:
                          nextPage = _context.sent;

                          _this.$router.push(nextPage);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), POST_NAVIGATION_DELAY);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};